<template>
    <div class="content-wrapper">
        <div class="flex mb-4">
            <div class="lg:w-full w-full bg-grid-color h-12">
                <vs-card class="px-5 py-5">
                    <section>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Logo</span>
                                <div style="font-size:0.75rem; color:#aaa;"></div>
                            </div>
                            <div class="vx-col sm:w-1/3 w-full">
                                <div>
                                    <img
                                        v-if="form.logo != null && form.logo != '' "
                                        :src="form.logo"
                                        :width="imageWidth"
                                        :height="imageHeight"
                                    />
                                    <div
                                        v-if="!form.logo"
                                        class="default-upload"
                                        style="width: 300px; height: 158px; background-color: #F5F5F5; border-radius: 8px; position: relative;"
                                    >
                                        <vs-button
                                            style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"
                                            color="dark"
                                            type="border"
                                            @click="chooseImage('logo')"
                                        >
                                            <span>Upload</span>
                                        </vs-button>
                                    </div>
                                </div>
                                <div
                                    class="grid-button-upload"
                                    style="margin-top: 8px; display: grid; grid-template-columns: repeat(2, min-content);grid-gap: 10px;"
                                >
                                    <!-- secondary / border  >> btn-->
                                    <vs-button
                                        v-if="form.logo"
                                        color="dark"
                                        type="border"
                                        icon="autorenew"
                                        style="display: flex"
                                        @click="chooseImage('logo')"
                                    >
                                        <span>Change</span>
                                    </vs-button>
                                    <input
                                        id="file-upload-img"
                                        @change="onUploadImages('logo')"
                                        type="file"
                                        ref="fileImage"
                                        :accept="acceptFile"
                                    >
                                    <vs-button
                                        v-if="form.logo"
                                        color="dark"
                                        type="border"
                                        icon="delete_forever"
                                        style="display: flex"
                                        @click="removeposter('logo')"
                                    >
                                        Remove
                                    </vs-button>
                                </div>
                                <!-- <vs-upload
                                    :multiple="false"
                                    :automatic="true"
                                    :single-upload="true"
                                    :fileName="`logo`"
                                    :limit="1"
                                    @change="successPosterUpload"
                                    @on-delete="deleteFileLogo"
                                    accept="image/png, image/jpeg, image/jpg, image/webp"
                                /> -->
                                <vs-input
                                    v-validate="{required: true}"
                                    name="logo"
                                    class="w-full"
                                    v-model="form.logo"
                                    style="display: none;"
                                />
                                <span class="text-danger text-sm" v-show="errors.has('logo')">
                                  The field is required
                                </span>
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Name</span>
                                <div style="font-size:0.75rem; color:#aaa;">
                                    Seller/Organizer Name
                                </div>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <vs-input
                                    v-validate="{required: true}"
                                    name="name"
                                    class="w-full"
                                    v-model="form.name"
                                    :maxLength="60"
                                />
                                <span class="text-danger text-sm" v-show="errors.has('name')">
                                    {{ splitError(errors.first('name'), 'name') }}
                                </span>
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Username</span>
                                <div style="font-size:0.75rem; color:#aaa;"></div>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <vs-input
                                    v-validate="{required: true, regex: /^([a-z0-9 -]+)$/}"
                                    name="folder"
                                    class="w-full"
                                    v-model="form.folder"
                                    :maxlength="24"
                                />
                                <span class="text-danger text-sm" v-show="errors.has('folder')">
                                    {{ splitError(errors.first('folder'), 'folder') }}
                                </span>
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Event Domain Name</span>
                                <div style="font-size:0.75rem; color:#aaa;">
                                    The domain you want to use. We will setup a subdomain as book.yourdomain.com
                                </div>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <vs-input
                                    v-validate="{regex:/^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/}"
                                    name="domain"
                                    class="w-full"
                                    v-model="form.domain"
                                />
                                <span class="text-danger text-sm" v-show="errors.has('domain')">
                                    {{ splitError(errors.first('domain'), 'domain') }}
                                </span>
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Time Zone</span>
                                <div style="font-size:0.75rem; color:#aaa;"></div>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <el-select
                                v-validate="'required'"
                                style="width: 100%"
                                v-model="form.timezone"
                                filterable
                                placeholder="Select timezone"
                                >
                                    <el-option
                                        v-for="item in timezones"
                                        :key="item.key"
                                        :label="item.value"
                                        :value="item.value"
                                    ></el-option>
                                </el-select>
                                <span
                                    class="text-danger text-sm"
                                    v-show="errors.has('timezone')"
                                >
                                    {{ errors.first("Time Zone") }}
                                </span>
                            </div>
                        </div>
                    </section>
                    <section>
                        <hr />
                        <h1 class="py-5">Confirmations & Tickets</h1>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Email Sender Name</span>
                                <div style="font-size:0.75rem; color:#aaa;">
                                    Must be Alpha-numeric characters that represent the company or brand
                                </div>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <vs-input
                                    class="w-full"
                                    v-model="form.emailfromname"
                                />
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Email Sender Email</span>
                                <div style="font-size:0.75rem; color:#aaa;">
                                    This will be used as "From" email for sending out confirmation and ticket emails
                                </div>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <vs-input
                                    v-validate="{regex: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/}"
                                    name="email"
                                    class="w-full"
                                    v-model="form.emailfromemail"
                                />
                                <span class="text-danger text-sm" v-show="errors.has('email')">
                                    {{ errors.first("email") }}
                                </span>
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>SMS Sender Name</span>
                                <div style="font-size:0.75rem; color:#aaa;">
                                   Limited to 11 characters only, without any space. Currently supported in Thailand Only.
                                </div>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <vs-input
                                    v-validate="{max: 11}"
                                    :maxlength="11"
                                    name="smssender"
                                    class="w-full"
                                    v-model="form.smssender"
                                    onkeypress="return /^[0-9]*\.?[a-zA-Z0-9]*$/i.test(event.key)"
                                />
                                <span class="text-danger text-sm" v-show="errors.has('smssender')">
                                    {{ errors.first("smssender") }}
                                </span>
                            </div>
                        </div>
                    </section>
                    <section>
                        <hr />
                        <h1 class="py-5">Contact Channels</h1>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Facebook Page</span>
                                <div style="font-size:0.75rem; color:#aaa;">
                                    You can get this from the URL of your Facebook Page
                                </div>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <vs-input
                                    class="w-full"
                                    v-model="form.fbpage"
                                    placeholder="Eg., SoldOuttLive"
                                />
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>LINE ID</span>
                                <div style="font-size:0.75rem; color:#aaa;"></div>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <vs-input
                                    class="w-full"
                                    v-model="form.lineid"
                                    placeholder="Eg., SoldOutt"
                                />
                            </div>
                        </div>
                    </section>
                    <section>
                        <hr />
                        <h1 class="py-5"></h1>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Text Color</span>
                                <div style="font-size:0.75rem; color:#aaa;">
                                    You can get this from the URL of your Facebook Page
                                </div>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <color-picker
                                    :color="form.txtcolor"
                                    :sucker-hide="true"
                                    :sucker-canvas="suckerCanvas"
                                    :sucker-area="suckerArea"
                                    @changeColor="changeTextColor"
                                />
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Background Color</span>
                                <div style="font-size:0.75rem; color:#aaa;"></div>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <color-picker
                                    :color="form.bgcolor"
                                    :sucker-hide="true"
                                    :sucker-canvas="suckerCanvas"
                                    :sucker-area="suckerArea"
                                    @changeColor="changeBgColor"
                                />
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Background Image</span>
                                <div style="font-size:0.75rem; color:#aaa;"></div>
                            </div>
                            <div class="vx-col sm:w-1/3 w-full">
                                <!-- <vs-upload
                                    :multiple="false"
                                    :automatic="true"
                                    :single-upload="true"
                                    :fileName="`bg`"
                                    :limit="1"
                                    @change="successBackgroundUpload"
                                    @on-delete="deleteFileBackground"
                                    accept="image/png, image/jpeg, image/jpg, image/webp"
                                /> -->
                                <div class="vx-col sm:w-1/3 w-full">
                                    <div>
                                        <img
                                            v-if="form.bgimg != null && form.bgimg != '' "
                                            :src="form.bgimg"
                                            :width="imageWidth"
                                            :height="imageHeight"
                                        />
                                        <div
                                            v-if="!form.bgimg"
                                            class="default-upload"
                                            style="width: 300px; height: 158px; background-color: #F5F5F5; border-radius: 8px; position: relative;"
                                        >
                                            <vs-button
                                                style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"
                                                color="dark"
                                                type="border"
                                                @click="chooseImage('bg')"
                                            >
                                                <span>Upload</span>
                                            </vs-button>
                                        </div>
                                    </div>
                                    <div
                                        class="grid-button-upload"
                                        style="margin-top: 8px;
                                                display: grid;
                                                grid-template-columns: repeat(2, min-content);
                                                grid-gap: 10px;"
                                    >
                                        <!-- secondary / border  >> btn-->
                                        <vs-button
                                            v-if="form.bgimg"
                                            color="dark"
                                            type="border"
                                            icon="autorenew"
                                            style="display: flex"
                                            @click="chooseImage('bg')"
                                        >
                                            <span>Change</span>
                                        </vs-button>
                                        <input
                                            id="file-upload-bg"
                                            @change="onUploadImages('bg')"
                                            type="file"
                                            ref="fileBg"
                                            :accept="acceptFile"
                                        >
                                        <vs-button
                                            v-if="form.bgimg"
                                            color="dark"
                                            type="border"
                                            icon="delete_forever"
                                            style="display: flex"
                                            @click="removeposter('bg')"
                                        >
                                            Remove
                                        </vs-button>
                                    </div>
                                    <!-- <vs-upload
                                        :multiple="false"
                                        :automatic="true"
                                        :single-upload="true"
                                        :fileName="`logo`"
                                        :limit="1"
                                        @change="successPosterUpload"
                                        @on-delete="deleteFileLogo"
                                        accept="image/png, image/jpeg, image/jpg, image/webp"
                                    /> -->
                                </div>
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Font</span>
                                <div style="font-size:0.75rem; color:#aaa;"></div>
                            </div>
                            <vs-select
                                autocomplete
                                @input-change="autoCompleteFunc"
                                class="vx-col sm:w-1/3 w-full"
                                v-model="form.font"
                                placeholder="Google Font"
                            >
                                <vs-select-item :key="index" :value="item.family" :text="item.family" v-for="(item,index) in fontList" />
                            </vs-select>
                        </div>
                    </section>
                    <section>
                        <hr />
                        <h1 class="py-5">Bank Transfer</h1>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Bank 1</span>
                                <div style="font-size:0.75rem; color:#aaa;"></div>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <!-- <vs-input
                                    class="w-full"
                                    v-model="form.bank1"
                                /> -->
                                <vs-select
                                    autocomplete
                                    @input-change="autoCompleteFunc"
                                    class="vx-col sm:w-1/3 w-full"
                                    v-model="form.bank1"
                                    placeholder="Bank Name"
                                >
                                    <vs-select-item :key="index" :value="item.code" :text="item.name" v-for="(item,index) in bankList" />
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Account Name</span>
                                <div style="font-size:0.75rem; color:#aaa;"></div>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <vs-input
                                    v-validate="{regex: /^[\u0E00-\u0E7FA-Za-z0-9., -]+$/}"
                                    name="bankaccname1"
                                    class="w-full"
                                    v-model="form.bankaccname1"
                                />
                                <span class="text-danger text-sm" v-show="errors.has('bankaccname1')">
                                    {{ errors.first("bankaccname1") }}
                                </span>
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Account Number </span>
                                <div style="font-size:0.75rem; color:#aaa;"></div>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <vs-input
                                    v-validate="{regex: /^[0-9 -]+$/}"
                                    :maxlength="16"
                                    name="bankaccno1"
                                    class="w-full"
                                    v-model="form.bankaccno1"
                                    onkeypress="return /^[- 0-9]/i.test(event.key)"
                                />
                                <span class="text-danger text-sm" v-show="errors.has('bankaccno1')">
                                    {{ errors.first("bankaccno1") }}
                                </span>
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Bank 2</span>
                                <div style="font-size:0.75rem; color:#aaa;"></div>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <vs-select
                                    autocomplete
                                    @input-change="autoCompleteFunc"
                                    class="vx-col sm:w-1/3 w-full"
                                    v-model="form.bank2"
                                    placeholder="Bank Name"
                                >
                                    <vs-select-item :key="index" :value="item.code" :text="item.name" v-for="(item,index) in bankList" />
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Account Name</span>
                                <div style="font-size:0.75rem; color:#aaa;"></div>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <vs-input
                                    v-validate="{regex: /^[\u0E00-\u0E7FA-Za-z0-9., -]+$/}"
                                    name="bankaccname2"
                                    class="w-full"
                                    v-model="form.bankaccname2"
                                />
                                <span class="text-danger text-sm" v-show="errors.has('bankaccname2')">
                                    {{ errors.first("bankaccname2") }}
                                </span>
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Account Number</span>
                                <div style="font-size:0.75rem; color:#aaa;"></div>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <vs-input
                                    v-validate="{regex: /^[0-9 -]+$/}"
                                    :maxlength="16"
                                    name="bankaccno2"
                                    class="w-full"
                                    v-model="form.bankaccno2"
                                    onkeypress="return /^[- 0-9]/i.test(event.key)"
                                />
                                <span class="text-danger text-sm" v-show="errors.has('bankaccno2')">
                                    {{ errors.first("bankaccno2") }}
                                </span>
                            </div>
                        </div>
                    </section>
                    <section>
                        <hr />
                        <h1 class="py-5">Tracking</h1>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Google Tag Manager ID</span>
                                <div style="font-size:0.75rem; color:#aaa;"></div>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <vs-input
                                    class="w-full"
                                    v-model="form.gtmid"
                                />
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Google Analytics ID</span>
                                <div style="font-size:0.75rem; color:#aaa;">
                                    You can get this from the Google Analytics account. For enhanced tracking, please turn on Ecommerce Tracking in Google Analytics.
                                </div>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <vs-input
                                    class="w-full"
                                    v-model="form.gaid"
                                    placeholder="Eg., UA-12345678-2"
                                />
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Facebook Pixel ID</span>
                                <div style="font-size:0.75rem; color:#aaa;">
                                    You can get this from the Facebook Pixel code
                                </div>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <vs-input
                                    class="w-full"
                                    v-model="form.fbpid"
                                    placeholder="Eg., 1696938513929033"
                                />
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Adwords ID</span>
                                <div style="font-size:0.75rem; color:#aaa;">
                                    You can get this from the Google Adwords tracking code
                                </div>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <vs-input
                                    class="w-full"
                                    v-model="form.awcid"
                                    placeholder="Eg., AW-123456789"
                                />
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Adwords Label</span>
                                <div style="font-size:0.75rem; color:#aaa;">
                                    You can get this from the Google Adwords tracking code
                                </div>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <vs-input
                                    class="w-full"
                                    v-model="form.awclabel"
                                    placeholder="Eg., OFWIFPDxlnxQrqfXiwD"
                                />
                            </div>
                        </div>
                    </section>
                    <section>
                        <hr />
                        <h1 class="py-5">Contact</h1>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Mobile No.</span>
                                <div style="font-size:0.75rem; color:#aaa;"></div>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <vs-input
                                    class="w-full"
                                    v-model="form.phone"
                                    onkeypress="return /^[-+0-9]/i.test(event.key)"
                                    onpaste="return false"
                                />
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Email</span>
                                <div style="font-size:0.75rem; color:#aaa;"></div>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <vs-input
                                    v-validate="{regex: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/}"
                                    name="email"
                                    class="w-full"
                                    v-model="form.email"
                                    :maxLength="254"
                                />
                                <span class="text-danger text-sm" v-show="errors.has('email')">
                                    {{ errors.first("email") }}
                                </span>
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Contact Person</span>
                                <div style="font-size:0.75rem; color:#aaa;"></div>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <vs-input
                                    class="w-full"
                                    v-model="form.contactperson"
                                    :maxLength="100"
                                />
                            </div>
                        </div>
                    </section>
                    <div style="height:30px;"></div>
                    <div class="vx-row pt-2 mt-0">
                        <div class="vx-col w-full ml-auto">
                            <vs-button class="mr-3 mb-2" @click="validateForm">
                                Save
                            </vs-button>

                            <vs-button class="mr-3 mb-2" type="border" @click="cancel()">
                                Cancel
                            </vs-button>
                        </div>
                    </div>
                </vs-card>
            </div>
        </div>
    </div>
</template>
<script>
import { Validator } from "vee-validate";
import { mapState } from "vuex";

import Service from "@/services";
import { eventFieldsPermission } from "@/utils/FieldsPermission";

import colorPicker from "@caohenghu/vue-colorpicker";
import { timezones } from "@/utils/Timezones";

const dict = {
  form: {
    name: {
      required: "Please enter an Seller/Organizer name"
    },
    folder: {
      required: "Please enter username",
    }
  }
};

Validator.localize("en", dict);
export default {
    components: {
        colorPicker
    },
    data() {
        return {
            eventFieldsPermission: eventFieldsPermission,
            posterUploadUrl: process.env.VUE_APP_API_URL + "/events/" + this.$route.query.e + "/merchant/upload",
            posterUploadHeader: {
                Authorization:
                "Bearer " +
                JSON.parse(localStorage.getItem("soldoutt-nimda")).Auth.accessToken
            },
            form: {
                logo: "",
                name: "",
                domain: "",
                folder: "",
                timezone: 'Asia/Bangkok',
                emailfromname: '',
                emailfromemail: '',
                smssender: '',
                fbpage: '',
                lineid: '',
                txtcolor: '',
                bgcolor: '',
                bgimg: '',
                font: '',
                bank1: '',
                bankaccname1: '',
                bankaccno1: '',
                bank2: '',
                bankaccname2: '',
                bankaccno2: '',
                gtmid: '',
                gaid: '',
                fbpid: '',
                awcid: '',
                awclabel: '',
                phone: '',
                email: '',
                contactperson: '',
            },
            suckerArea: [],
            suckerCanvas: null,
            posterData: {
                type: "poster"
            },
            bgImgData: {
                type: "bgimg"
            },
            timezones: timezones,
            fontList: [],
            logo: '',
            bankList: [
                {
                    name: 'Kasikorn Bank',
                    code: 'kbank'
                },
                {
                    name: 'Siam Commercial Bank',
                    code: 'scb'
                },
                {
                    name: 'Krungthai Bank',
                    code: 'ktb'
                },
                {
                    name: 'Bank of Ayudhya',
                    code: 'bay'
                },
                {
                    name: 'Bangkok Bank',
                    code: 'bbl'
                }
            ],
            role: 'user',
            imageWidth: 0,
            imageHeight: 0,
            acceptFile: [
                'image/png',
                'image/jpeg',
                'image/jpg',
                'image/webp',
            ],
            logoUpdate: null,
            bgUpdate: null
        }
    },
    computed: {
        ...mapState({
        accessToken: state => {
            return state.Auth.accessToken;
        },
        s: state => {
            return state.Utility.s;
        },
        e: state => {
            return state.Utility.e;
        }
        })
    },
    created() {
        this.timezones = Object.keys(this.timezones).map(item => {
            return { key: item, value: item };
        });
    },
    watch: {
        'form.name': function(newVal, oldVal) {
            var slugify = require("slugify");
            this.form.slug = slugify(newVal, {
                replacement: "-", // replace spaces with replacement character, defaults to `-`
                remove: /[*#+~%^&*.()๋ัฤ็ฺ๋?ฦ๐ํ๊ฯ,ๆำๅกขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรลวศษสอหฬฮะาิีุูึ์ ืแโใไ๑๒๓๔ู฿๕๖๗๘๙่เ้'"!:@=]/g, // remove characters that match regex, defaults to `undefined`
                lower: true, // convert to lower case, defaults to `false`
                strict: false // strip special characters except replacement, defaults to `false`
            });
        },

    },
    // mounted() {
      // this.form.folder = this.s;
    // },
    methods: {
        splitError(val, word) {
            if (!val) {
                return
            }
            else {
                const data = val.split(word)
                return data[0] + data[1]
            }
        },
        changeTextColor(color) {
            this.form.txtcolor = color.hex;
        },
        changeBgColor(color) {
            this.form.bgcolor = color.hex;
        },
        // successPosterUpload(res, file) {
        //     this.form.logo = file[0]
        // },
        // deleteFileLogo(res) {
        //     if (res) {
        //         this.form.logo = null
        //     }
        // },
        successBackgroundUpload(res, file) {
            this.form.bgimg = file[0]
        },
        deleteFileBackground(res) {
            if (res) {
                this.form.bgimg = null
            }
        },
        validateForm() {
            // this.form.folder = this.s;


            this.$validator.validateAll().then(result => {
                if (result) {
                // if form have no errors
                this.submit();
                } else {
                // form have errors
                }
            });
        },
        submit() {
            // this.$vs.loading();
            const formData = new FormData();
            const dataKeyForms = Object.keys(this.form);
            for (let index = 0; index < dataKeyForms.length; index++) {
                const key = dataKeyForms[index];
                const value = this.form[key];
                formData.append(key,value);
            }
            formData.set('logo', this.logoUpdate)
            formData.set('bgimg', this.bgUpdate)

            Service.Merchant.create(formData, this.s)
                .then((res) => {
                    // console.log(res, 'create')
                    this.$vs.notify({
                        title: "Success",
                        text: "Update complete.",
                        color: "success"
                    });
                    // this.$router.push("/sellers?s=" + this.s + "&e=" + this.e);
                    this.$router.push("/events/addfirst/" + res.data.merchant_id);

                    this.$vs.loading.close();
                })
                .catch(err => {
                this.$vs.notify({
                    title: "Oops!",
                    text: "ERROR : " + err.error,
                    color: "danger"
                });
                this.$vs.loading.close();
                });
        },
        cancel() {
            this.$router.push("/sellers?s=" + this.s + "&e=" + this.e);
        },
        autoCompleteFunc(val) {},
        getFont() {
            Service.Font.getFontList()
                .then(response => {
                    this.fontList = response.items
                })
                .catch(() => {})
        },
        getRole() {
            const folder = this.$route.query.e
            Service.Event.get(folder)
                .then(res => {
                    this.role = res.data.role;
                    if (this.role === 'so-admin' || this.role === 'so-owner') {
                        this.isRequired = true
                    }
                })
                .catch(() => {})
        },
        removeposter(val) {
            if (val === 'logo') {
                this.form.logo = null
            }
            else {
                this.form.bgimg = null
            }
        },
        chooseImage(val) {
            if (val === 'logo') {
                document.getElementById("file-upload-img").click()
            }
            else {
                document.getElementById("file-upload-bg").click()
            }

        },
        onUploadImages(val) {
            if (val === 'logo') {
                this.form.logo = this.$refs.fileImage.files[0]
                this.logoUpdate = this.$refs.fileImage.files[0]
                const reader = new FileReader()
                reader.onloadend = async() => {
                    this.form.logo = reader.result
                    // this.posterUpdate = reader.result
                    this.setImageSize()
                }
                reader.readAsDataURL(this.$refs.fileImage.files[0])
                this.$refs.fileImage.value = null
            }
            else {
                this.form.bgimg = this.$refs.fileBg.files[0]
                this.bgUpdate = this.$refs.fileBg.files[0]
                const reader = new FileReader()
                reader.onloadend = async() => {
                    this.form.bgimg = reader.result
                    // this.posterUpdate = reader.result
                    this.setImageSize()
                }
                reader.readAsDataURL(this.$refs.fileBg.files[0])
                this.$refs.fileBg.value = null
            }
        },
        setImageSize () {
            let posterimage = document.querySelector('img')
            let w = posterimage.naturalWidth;
            let h = posterimage.naturalHeight;
            this.imageHeight = h
            this.imageWidth = w

            if (w > h) {
                this.imageWidth = 300
                this.imageHeight = 'auto'
            }
            else {
                this.imageHeight = 300
                this.imageWidth = 'auto'
            }
        },
    },
    mounted() {
        this.getFont()
        this.getRole()
    }
};
</script>

<style scoped>
input[type="file"] {
	display: none !important;
}
</style>
